<div class="text-center mt-5">
  <img src="/assets/images/empty-graphic.svg" alt="Empty Graphic"/>
  <div class="text-label">
    You are not following any
    <ng-container *ngIf="currentConfig.key === 'apps'">mobile apps</ng-container>
    <ng-container *ngIf="currentConfig.key === 'ctv'">connected tv apps</ng-container>
    <ng-container *ngIf="currentConfig.key === 'domains'">domains</ng-container>
    .
  </div>
  <button class="btn btn-primary discovery-apps" (click)="closeFollowing()">
    Discover
    <ng-container *ngIf="currentConfig.key === 'domains'">Domains</ng-container>
    <ng-container *ngIf="currentConfig.key !== 'domains'">Apps</ng-container>
  </button>
</div>


